import React, { FC } from 'react';
import TruncateComponent from './Truncate';
import { TruncateProps } from '$shared/components/Truncate/Truncate.interface';

export const Truncate: FC<TruncateProps> = (props) => {
  return <TruncateComponent {...props} />;
};

// const TruncateComponent = lazy(() => retry(() => import('./Truncate'))) as any;
//
// export const Truncate: FC<TruncateProps> = (props) => {
//   return (
//     <Suspense fallback={<div>Loading...</div>}>
//       <TruncateComponent {...props} />
//     </Suspense>
//   );
// };
